export const sidebarAction = (name, channel) => ({
  type: 'SIDEBAR',
  name,
  channel,
})
